import Expander from './Expander.vue';
export default Expander;
